import { TeacherVideoModal_TeacherFragment } from "@outschool/gql-frontend-generated";
import { useTrackEvent } from "@outschool/ui-analytics";
import { gql, useQuery } from "@outschool/ui-apollo";
import { TeacherVideoModal } from "@outschool/ui-components-website";
import { useEffect, useState } from "react";

const tutorVideoCarouselQuery = gql`
  query TutorVideoCarousel {
    featured {
      popularTutorListings {
        leader {
          ...TeacherVideoModal_teacher
        }
      }
    }
  }
  ${TeacherVideoModal.fragments.teacher}
`;

export const useTutorData = () => {
  const { data, loading, error } = useQuery(tutorVideoCarouselQuery, {
    context: { doNotRetry: true }
  });
  const [selectedTeacher, setSelectedTeacher] =
    useState<TeacherVideoModal_TeacherFragment | null>(null);

  const tutors =
    loading || error
      ? []
      : data?.featured.popularTutorListings.map(
          (listing: { leader: TeacherVideoModal_TeacherFragment }) =>
            listing.leader
        ) || [];

  const getNextTeacher = (currentUid: string) => {
    const currentIndex = tutors.findIndex(
      (tutor: TeacherVideoModal_TeacherFragment) => tutor.uid === currentUid
    );
    // Wraps around to the first tutor
    const nextIndex = (currentIndex + 1) % tutors.length;
    return tutors[nextIndex];
  };

  const getPreviousTeacher = (currentUid: string) => {
    const currentIndex = tutors.findIndex(
      (tutor: TeacherVideoModal_TeacherFragment) => tutor.uid === currentUid
    );
    // Wraps around to the last tutor
    const previousIndex = (currentIndex - 1 + tutors.length) % tutors.length;
    return tutors[previousIndex];
  };

  const handleNextTeacher = () => {
    if (selectedTeacher) {
      const nextTeacher = getNextTeacher(selectedTeacher.uid);
      setSelectedTeacher(nextTeacher);
    }
  };

  const handlePreviousTeacher = () => {
    if (selectedTeacher) {
      const previousTeacher = getPreviousTeacher(selectedTeacher.uid);
      setSelectedTeacher(previousTeacher);
    }
  };

  const trackEvent = useTrackEvent();
  useEffect(() => {
    if (selectedTeacher) {
      trackEvent("tutor_video_carousel_tutor_selected", {
        leader_uid: selectedTeacher.uid
      });
    }
  }, [selectedTeacher, trackEvent]);

  return {
    tutors,
    loading,
    selectedTeacher,
    setSelectedTeacher,
    handleNextTeacher,
    handlePreviousTeacher
  };
};
